import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js";
import "core-js/es/set";
import "core-js/es/map";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById("root")
// );

import { createRoot } from "react-dom/client";
createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById("root")
);
